import React from "react";
import { PUT } from "lib/api";
import Checker from "./checker";
import { autobind } from "lib/decorators";
require("./style.css");

export default class PasswordManager extends Checker {
  constructor(props, context) {
    super(props, context);
  }

  @autobind
  async updatePassword() {
    let errors = {};
    let saveError = "-";
    let { current, next, repeat } = this.refs;
    let nextVal = next.value;

    this.checkPolicy(nextVal, errors);

    Object.keys(this.refs).forEach((k) => {
      let key = "error_" + k;

      if (!this.refs[k].value)
        this.addError(
          errors,
          key,
          this.l(k == "repeat" ? "lblVerifyPassword" : "enterPassWord"),
        );
    });

    if (nextVal != repeat.value)
      this.addError(errors, "error_repeat", this.l("passwordsDontMatch"));

    if (Object.keys(errors).length <= 0) {
      saveError = await PUT(
        "v1/setpassword",
        {},
        { old: current.value, new: nextVal },
      );

      if (saveError) this.addError(errors, "error_current", this.l(saveError));
    }

    this.setState({ errors, didSave: saveError === "" });
  }

  @autobind
  submitOnEnter(e) {
    if (e.keyCode == 13) {
      this.updatePassword();
      e.preventDefault();
    }
  }

  doRender() {
    let { ready, errors, didSave } = this.state || {};

    if (!ready) return <div />;

    let {
      error_current = [],
      error_next = [],
      error_repeat = [],
    } = errors || {};

    return (
      <div>
        {didSave && (
          <div id="cPlhMain_DivInfoPwd" className="info-message tag tag-info">
            {this.l("infosaved")}
          </div>
        )}

        <div className="flex align-c relative flex-wrap">
          <div className="passwordmanager-column">
            <label htmlFor="passwordmanager-current">
              {this.l("hdrPresentPwd")}:
            </label>
          </div>
          <br />
          <input
            id="passwordmanager-current"
            type="password"
            ref="current"
            onKeyDown={this.submitOnEnter}
            maxLength="255"
          />
          <span className="passwordmanager-error animated fadeInDown">
            {error_current.map((e, i) => (
              <span key={i}>
                {e}
                <br />
              </span>
            ))}
          </span>
        </div>

        <br />

        <div className="flex align-c relative flex-wrap">
          <div className="passwordmanager-column">
            <label htmlFor="passwordmanager-next">{this.l("hdrnewpwd")}:</label>
          </div>
          <br />
          <input
            id="passwordmanager-next"
            type="password"
            ref="next"
            onKeyDown={this.submitOnEnter}
            maxLength="255"
          />
          <span className="passwordmanager-error animated fadeInDown">
            {error_next.map((e, i) => (
              <span key={i}>
                {e}
                <br />
              </span>
            ))}
          </span>
        </div>

        <br />

        <div className="flex align-c relative flex-wrap">
          <div className="passwordmanager-column">
            <label htmlFor="passwordmanager-repeat">
              {this.l("lblVerifyPassword")}:
            </label>
          </div>
          <br />
          <input
            id="passwordmanager-repeat"
            type="password"
            ref="repeat"
            onKeyDown={this.submitOnEnter}
            maxLength="255"
          />
          <span className="passwordmanager-error animated fadeInDown">
            {error_repeat.map((e, i) => (
              <span key={i}>
                {e}
                <br />
              </span>
            ))}
          </span>
        </div>
        <br />
        <div>
          <button
            type="button"
            className="button-cta"
            onClick={this.updatePassword}
          >
            {this.l("save")}
          </button>
        </div>
      </div>
    );
  }
}
